// extracted by mini-css-extract-plugin
export var readonly = "_hj-1";
export var star = "_hj-0";